import { site } from '../data/site'

export default function About() {
  return (
    <section id="about" className="bg-navy text-white">
      <div className="w-full px-6 sm:px-10 lg:px-16 py-20 grid lg:grid-cols-3 gap-10">
        <div className="lg:col-span-1">
          <div className="text-xs tracking-widest text-white/50 font-semibold">
            ABOUT
          </div>
          <h2 className="mt-3 text-3xl font-bold">시스템 소개</h2>
        </div>

        <div className="lg:col-span-2 space-y-5 text-white/80 leading-relaxed">
          <p>
            <b className="text-white">{site.name}</b>({site.fullName})는
            국내 주요 식물병인 과수화상병, 도열병, 소나무재선충병의 확산을
            <b className="text-white"> 뉴스 기사 단위로 추적</b>하는 공개
            대시보드입니다. 기사 수집 → 자연어 처리 → 발생 지역 추출 →
            지도·통계 시각화의 파이프라인을 통해, 기존 행정 통계가 따라잡지
            못하는 <b className="text-white">속보성 신호</b>를 조기에
            포착합니다.
          </p>
          <p>
            데이터는 일 단위로 갱신되며, 사용자는 병해별로 기사 년도별
            발생횟수·시군구별 누적 발생·최신 기사 원문을 한 화면에서 확인할 수
            있습니다.
          </p>
          <p className="text-sm text-white/60">
            운영: {site.lab} · 문의:{' '}
            <a
              href={`mailto:${site.email}`}
              className="text-brand-light hover:underline"
            >
              {site.email}
            </a>
          </p>
        </div>
      </div>
    </section>
  )
}
